import { FC } from "react";
import { ChatButtonProps } from "./types";
import { Column } from "../../../../components/containers";
import { useThemeStore } from "../../../../stores";
import { JustifyContent } from "../../../../components/containers/types";

const ChatButton: FC<ChatButtonProps> = ({
  Icon,
  onClick = () => {},
  props,
  className = "",
  style = {},
}) => {
  const theme = useThemeStore((s) => s.theme);

  return (
    <Column
      background={theme.chat.primary}
      justifyContent={JustifyContent.Center}
      style={{
        width: 30,
        height: 30,
        borderRadius: "50%",
        cursor: "pointer",
        ...style,
      }}
      className={className}
      props={{ onClick, ...props }}
    >
      <Icon color={theme.chat.textOnPrimary} />
    </Column>
  );
};

export default ChatButton;
